import { jsx as N } from "react/jsx-runtime";
import { createContext as w, useContext as C } from "react";
import { notifications as v } from "../../queries/notifications/index.js";
import { useAuth as R } from "../auth/index.js";
import { useSchool as y } from "../school/index.js";
const r = w(void 0), E = ({ children: o }) => {
  const { data: f, isPending: m, refetch: i, isFetched: p, fetchNextPage: u, isFetchingNextPage: l, hasNextPage: d } = new v.get({ notificationsPerPage: 10 }).ToQuery(), { Post: h, Get: a } = R(), { baseUrl: e } = y(), s = f, c = [];
  s == null || s.pages.forEach((t) => t.map((n) => {
    c.push(n);
  }));
  const g = async (t) => {
    (await h({
      url: `${e}/lms/api/coms/notifications/setreadfromprops`,
      data: t,
      config: null
    })).NotificationID && i();
  }, x = async (t = 0) => {
    (await a({
      url: `${e}/lms/api/coms/notifications/setread/${t}`,
      config: { asResponse: !0 },
      data: null
    })).ok && i();
  }, P = async () => {
    (await a({
      url: `${e}/lms/api/coms/notifications/setread`,
      config: { asResponse: !0 },
      data: null
    })).ok && i();
  };
  return /* @__PURE__ */ N(r.Provider, { value: {
    isPending: m,
    notifications: c,
    setReadFromProps: g,
    setRead: x,
    setAllRead: P,
    initialFetchComplete: p,
    fetchNextPage: u,
    isFetchingNextPage: l,
    hasNextPage: d
  }, children: o });
}, I = () => {
  const o = C(r);
  if (!o)
    throw new Error("useNotifications must be used within an NotificationContextProvider");
  return o;
};
export {
  E as NotificationContextProvider,
  I as useNotifications
};
//# sourceMappingURL=index.js.map
